module.exports = __webpack_public_path__ + "static/media/endorsement_grey.d08a3be4.svg";